export default __webpack_public_path__ + "static/media/icon-node-tipo-aula.3f7b8dc1.svg";